var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNohao(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 96,
    viewBox: "0 0 126 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_367_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.629 0H64.9681C53.1596 0 43.5967 9.60514 43.5967 21.4466C43.5967 33.2967 53.1681 42.8933 64.9681 42.8933H104.629C116.437 42.8933 126 33.2881 126 21.4466C126 9.59657 116.429 0 104.629 0ZM104.629 36.1242C96.5513 36.1242 90.0025 29.5523 90.0025 21.4466C90.0025 13.341 96.5513 6.76901 104.629 6.76901C112.706 6.76901 119.255 13.341 119.255 21.4466C119.255 29.5523 112.706 36.1242 104.629 36.1242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.629 53.1067C92.8201 53.1067 83.2572 62.7118 83.2572 74.5533C83.2572 86.4034 92.8286 95.9999 104.629 95.9999C116.437 95.9999 126 86.3948 126 74.5533C126 62.7033 116.429 53.1067 104.629 53.1067ZM104.629 89.2309C96.5513 89.2309 90.0024 82.659 90.0024 74.5533C90.0024 66.4476 96.5513 59.8757 104.629 59.8757C112.706 59.8757 119.255 66.4476 119.255 74.5533C119.255 82.659 112.706 89.2309 104.629 89.2309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.602 79.7029H16.1887V96H0.563538V53.0981H16.1801V68.3156H21.5934V53.0981H37.21V96H21.5934V79.7029H21.602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9169 88.4512H56.4212L55.3369 96H39.4897L48.8904 53.0981H72.4306L81.8313 96H65.9842L64.8998 88.4512H64.9169ZM58.0777 77.1238H63.2604L61.7748 66.8247H59.5548L58.0691 77.1238H58.0777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 42.9018V0H15.8984L24.5647 18.302H26.5029V0H40.7534V42.9018H24.283L16.1887 24.5998H14.2505V42.9018H0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 96,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNohao);
export default __webpack_public_path__ + "static/media/nohao.c0564e3c4d9c84a12a70b87c66fb92d2.svg";
export { ForwardRef as ReactComponent };